import { FormFieldType, TFormField } from '@models/forms';
import { engineRegExp } from '@lio/rule-engine';
import { getNumbers } from '@utils/regex';
import { CreatePasswordField } from '@pages/Login/SignUpView/CreatePasswordField';
import { LoginSource } from '@pages/Login/constants';
import { IndicationSummaryGetResponse } from '@lio/api-types';

export const getFormFields = ({ loginSource }: { loginSource?: LoginSource }): { [fieldName: string]: TFormField } => ({
  firstName: {
    gridWidth: { xs: 12 },
    name: 'firstName',
    label: 'First Name',
    fieldType: FormFieldType.TextField,
    required: true,
    helperText: '', // will suppress length helper text
    fieldConfig: {
      textField: {
        maxLength: 51, // okta max length
      },
    },
  },
  lastName: {
    gridWidth: { xs: 12 },
    name: 'lastName',
    label: 'Last Name',
    helperText: '', // will suppress length helper text
    fieldType: FormFieldType.TextField,
    required: true,
    fieldConfig: {
      textField: {
        maxLength: 51, // okta max length
      },
    },
  },
  email: {
    gridWidth: { xs: 12 },
    name: 'email',
    label: 'Email',
    fieldType: FormFieldType.TextField,
    disabled: loginSource === LoginSource.INDICATION,
    required: true,
    helperText:
      loginSource === LoginSource.INDICATION ? 'This email address is associated with the indication creator' : '',
    fieldConfig: {
      textField: {
        regexPattern: engineRegExp.email.regExp,
        regexMessage: 'The email address is not valid',
        autocomplete: 'new-password',
      },
    },
  },
  password: {
    gridWidth: { xs: 12 },
    name: 'password',
    label: 'Password',
    fieldType: FormFieldType.CustomField,
    required: true,
    fieldConfig: {
      customField: {
        Component: CreatePasswordField,
      },
    },
  },
});

export const getPartnerFields = ({
  indicationSummary,
}: {
  indicationSummary?: IndicationSummaryGetResponse;
}): { [fieldName: string]: TFormField } => ({
  partnerId: {
    gridWidth: { xs: 12 },
    name: 'partnerId',
    label: 'Partner ID',
    fieldType: FormFieldType.TextField,
    disabled: !!indicationSummary,
    required: true,
    helperText: indicationSummary ? `This is associated with ${indicationSummary.brokerage?.name}` : '',
    fieldConfig: {
      textField: {
        handleOnPattern: (value) => {
          return getNumbers(value);
        },
      },
    },
  },
});
